import {
  WSBreadcrumbsItem,
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { PayerStatus } from "@wingspanhq/wingspan-api-sdk";
import { queriesPayers } from "@query";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { WSQueries } from "../../../query/WSQuery";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { selectorPayerDisplayName } from "../../../shared/selectors/selectorPayerDisplayName";
import { usePayerHistoryResources } from "../hooks/usePayerHistoryResources";
import { getPayerDetailsUrl, PAYERS_PATH } from "../paths";

export const RoutePayerHistory: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch<{ payerId: string }>();
  const payerId = match.params.payerId;
  const queryClient = queriesPayers.getPayer.useQuery(
    { payerId },
    { retry: false }
  );

  const historyResources = usePayerHistoryResources(payerId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryClient
        }}
      >
        {({ queryClientData: client }) => {
          const clientName = selectorPayerDisplayName(client);

          const isInactive = client.status !== PayerStatus.ACTIVATED;

          return (
            <>
              <WSPageToolbar
                title="Client history"
                breadcrumbs={[
                  {
                    label: "Clients",
                    onClick: () => {
                      history.push(PAYERS_PATH);
                    }
                  },
                  ...(isInactive
                    ? [
                        {
                          label: "Archived clients",
                          onClick: () => {
                            history.push(`${PAYERS_PATH}/archived`);
                          }
                        } as WSBreadcrumbsItem
                      ]
                    : []),
                  {
                    label: clientName,
                    onClick: () => {
                      history.push(getPayerDetailsUrl(payerId));
                    }
                  },
                  {
                    label: "Client history"
                  }
                ]}
              />

              <WSGrid>
                <WSGrid.Item span={{ l: "8" }}>
                  <WSList gap="2XL">
                    <ResourceHistory resources={historyResources} />
                  </WSList>
                </WSGrid.Item>
              </WSGrid>
            </>
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
